import React from 'react'
import styled, { css } from 'styled-components'
import { transparentize } from 'polished'
import {
  Title as ErrorMessageTitle,
  Body as ErrorMessageBody,
  Container,
} from 'components/ErrorMessage/ErrorMessage'
import { ReactComponent as WarningTriangle } from 'icons/warning-triangle-64.svg'

export const Title = styled(ErrorMessageTitle)(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.little};
    color: ${transparentize(1 - 0.75, theme.colors.black)};
  `
)

const Body = styled(ErrorMessageBody)(
  ({ theme }) => css`
    font-size: ${theme.fontSizes.little};
    color: ${transparentize(1 - 0.5, theme.colors.black)};
  `
)

const IconContainer = styled.div`
  width: 28px;
  height: 28px;
  color: ${({ theme }) => theme.colors.state.disabled};
`

const GroupsError: React.FC = () => {
  return (
    <Container>
      <IconContainer>
        <WarningTriangle />
      </IconContainer>
      <Title>Unable to load groups</Title>
      <Body>
        Something went wrong while loading the components&apos; groups. Refresh
        the page to try again.
      </Body>
    </Container>
  )
}

export default GroupsError
